<template>
    <div>
        <div v-if="verifying" class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-alert v-else-if="!warningConfirmed && !verifying"
                class="mx-5 body-2"  color="primary" border="left"
                elevation="2" colored-border icon="mdi-alert">
            <div v-if="!editedByMe">
                <p class="font-weight-bold">ACHTUNG: Dieses Spiel wird bereits durch jemanden bearbeitet!</p>
                <p>Bitte stelle sicher, dass andere Benutzer/Innen die Bearbeitung unterbrechen bevor du deine
                    Änderung vornimmst. Anderenfalls kann es passieren, dass deine Eingaben durch andere
                    Benutzer/Innen wieder überschrieben werden.</p>
            </div>
            <div v-else>
                <p class="font-weight-bold">ACHTUNG: Du bearbeitest dieses Spiel bereits in einem
                    anderen Fenster oder auf einem anderen Gerät!</p>
                <p>Bitte schließe zuerst alle anderen Eingabefenster für dieses Spiel. Anderenfalls kann es sein,
                    dass deine Eingaben verloren gehen.</p>
            </div>
            <v-btn color="primary" @click="setConfirmed()">Trotzdem bearbeiten</v-btn>
        </v-alert>
    </div>
</template>

<script>
    import {db} from "../../../../services/db";
    export default {
        name: "spiel-bericht-edit-alert",
        props: ['dataObject', 'warningConfirmed'],
        computed: {
            user(){ return this.$store.state.user; }
        },
        data: () => ({
            confirmed: false,
            verifying: true,
            editedByMe: false,
        }),
        created(){
            this.initProcessStatus();
        },
        destroyed(){
            if ( this.warningConfirmed ) { this.confirmed = true; }
            if ( this.editedByMe && this.confirmed ) {
                this.deleteSpielEdited();
            }
        },
        methods: {
            initProcessStatus(){
                db.collection("spieleEdited").doc(this.dataObject.id).get()
                .then((doc) => {
                    if (doc.exists) {
                    // display warning
                        this.verifying = false;
                        if ( doc.data().uid === this.user.uid ) {
                            this.editedByMe = true;
                        }
                    } else {
                    // set for current user and release window
                        this.verifying = false;
                        this.editedByMe = true;
                        this.setSpielEdited();
                        this.setConfirmed();
                    }
                }).catch((error) => {
                    console.log("Error getting document from spieleEdited", error);
                });
            },
            setSpielEdited(){
                db.collection("spieleEdited").doc(this.dataObject.id).set({
                    uid: this.user.uid,
                })
                    .then(() => {
                        console.log("Document successfully written to spieleEdited!");
                    })
                    .catch((error) => {
                        console.error("Error writing document to spieleEdited: ", error);
                    });
            },
            deleteSpielEdited(){
                db.collection("spieleEdited").doc(this.dataObject.id)
                    .delete()
                .then(() => {
                    console.log("Document successfully deleted from spieleEdited!");
                }).catch((error) => {
                    console.error("Error removing document from spieleEdited: ", error);
                });
            },
            setConfirmed(){
                this.confirmed = true;
                this.$emit('confirmed');
            }
        },
    }
</script>

<style scoped>

</style>